import dayjs from 'dayjs';
import {
  Button,
  CreditCardIcon,
  PageHeading,
  Paragraph,
} from '@quickmd-llc/design-system';
import { RefillOrderSummary } from './RefillOrderSummary';
import { RefillDeliveryAddress } from './RefillDeliveryAddress';
import { useRefillCheckup } from '../hooks/useRefillCheckup';
import { useBuildPatientAppUrl } from '@hooks';

export function OrderConfirmationSlide() {
  const { creditCard } = useRefillCheckup();
  const patientWebUrl = useBuildPatientAppUrl({ page: 'onboarding' });

  function handleDoneClick() {
    window.location.href = patientWebUrl;
  }

  return (
    <>
      <div className="flex-1">
        <PageHeading className="mb-4">Thanks for Your Order!</PageHeading>

        <Paragraph className="mb-4 font-semibold">
          Your order is being processed...
        </Paragraph>

        <div className="mb-6">
          <RefillOrderSummary isOrderConfirmation />
        </div>

        {creditCard && (
          <div className="mb-6">
            <Paragraph className="mb-2 font-semibold text-shade-95">
              Payment Method
            </Paragraph>

            <div className="flex flex-row items-center gap-2 self-center">
              <CreditCardIcon type={creditCard.type} size="lg" />

              <Paragraph className="font-semibold text-text-dark">
                {creditCard.number.slice(4)}
              </Paragraph>

              <Paragraph size="sm" className="self-center text-shade-80">
                {dayjs(creditCard.expiry, 'YYYY-MM').format('MM/YY')}
              </Paragraph>
            </div>
          </div>
        )}

        <div className="mb-6">
          <RefillDeliveryAddress hideSubtext />
        </div>
      </div>

      <Button
        className="mt-auto w-full"
        type="button"
        onClick={handleDoneClick}
      >
        Done
      </Button>
    </>
  );
}
